import { Common, color, utils } from '@stockbit/ui';
import { ModalConfirm } from './styled';

const { Text, Button, Flex } = Common;
const { hexOpacity } = utils;

interface ModalMaximumSizeProps {
  onCancel: () => void;
  [key: string]: any;
}

function ModalMaximumSize({ onCancel, isLoading, ...props }: ModalMaximumSizeProps) {
  return (
    <ModalConfirm
      onCancel={onCancel}
      centered
      closable={false}
      width={400}
      title={(
        <Text size="20px" height="40px" family="bold" pt="20px" pl="20px" pr="20px">
          File too large
        </Text>
      )}
      footer={(
        <Flex pb="20px" px="20px" justify="flex-end" align="flex-end">
          <Button
            key="confirm"
            type="primary"
            padding="10px 30px"
            width="80px"
            height="40px"
            radius="4px"
            onClick={onCancel}
          >
            OK
          </Button>
        </Flex>
      )}
      maskStyle={{ backgroundColor: `${color.black}${hexOpacity(80)}` }}
      {...props}
    >
      <Text pt="10px" pb="20px" px="20px">
        File is too large and cannot be uploaded. The maximum size for each file is 2MB
      </Text>
    </ModalConfirm>
  );
}

export default ModalMaximumSize;
